import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import Button from "react-bootstrap-button-loader";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

// constants
import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT_WITH_TIME,
  DEVELOPMENT_TYPE,
} from "Constants";
import LocaleStrings from "Languages";

// actions
import {
  fetchUserListEditLeaderBoard,
  addExtraPointsModal,
} from "LeaderboardActions";
import { editDashboardUser } from "DashboardUserAction";

class LeaderboardUserItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
    };
  }

  editUser(userid) {
    this.props.fetchUserListEditLeaderBoard(
      this.props.session,
      userid,
      (response) => {
        this.props.editDashboardUser(response.data[0]);
      }
    );
  }

  render() {
    const { isadmin, appuserid, position } = this.props;

    var selectedUsers = this.props.selectedUsers;
    var user = this.props.appUser;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    var checked = false;
    if (index >= 0) {
      checked = true;
    }
    var profileImageUrl = "../../style/images/custom-icons/user_2.png";

    if (
      this.props.appUser.profileurl &&
      this.props.appUser.profileurl !== "" &&
      this.props.appUser.profileurl !== null
    ) {
      profileImageUrl = `${BASE_IMAGES_URL}/${this.props.appUser.profileurl}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${profileImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "10px",
      backgroundPosition: "50% 50%",
      cursor: "pointer",
    };

    return (
      <tr
        key={this.props.appUser.username}
        id={this.props.appUser.username}
        style={checked ? { backgroundColor: "#fff" } : {}}
      >
        <td>
          <div
            className="row-"
            style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
          >
            <div className="vcenter">
              <b>
                {this.props.appUser.position
                  ? this.props.appUser.position
                  : "N/A"}
              </b>
            </div>
          </div>
        </td>
        <td>
          <div
            className="row-"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
          >
            <div className="" style={{ marginRight: 15 }}>
              <div
                onClick={() => this.editUser(this.props.appUser.id)}
                style={style}
              ></div>
            </div>
            <div className="vcenter">
              <a className="custom-a-tag">
                <b onClick={() => this.editUser(this.props.appUser.id)}>
                  {" "}
                  {this.props.appUser.username}{" "}
                </b>
              </a>
              <span className="label-mandatory">
                {isadmin === "1" ? `(${LocaleStrings.admin})` : ""}
              </span>
            </div>
          </div>
        </td>
        <td>
          <div
            className="row-"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
          >
            <div className="vcenter ">
              <span className="points-text">
                {this.props.appUser.totalpoints
                  ? this.props.appUser.totalpoints + ` pts`
                  : "N/A"}
              </span>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {
  fetchUserListEditLeaderBoard,
  editDashboardUser,
  addExtraPointsModal,
})(LeaderboardUserItem);
